import styled from 'theme';

export const CertificatesGroupWrapper = styled.div`
  margin-top: 2rem;
  margin-bottom: 2rem;
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
`;

export const CertificatesGroupTitle = styled.div`
  flex: 1 1 auto;
  font-family: ${props => props.theme.variables.typography.secondaryFont};
  font-size: ${p => p.theme.variables.fonts.size.smaller0};
  font-weight: ${p => p.theme.variables.fonts.weight.bold};
  line-height: 1;
  color: ${props => props.theme.variables.customColors.leadingColor.base};
  margin-bottom: 1.5rem;
`;

export const CertificatesGroupTable = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  & div:nth-child(even) {
    background-color: ${props => props.theme.variables.customColors.superLightGrey};
  }

  & div.loader-container {
    background-color: inherit;
  }
`;

export interface IBaseColumnProps {
  isLastColumn?: boolean;
}
export const BaseItemWidth = styled.span<IBaseColumnProps>`
  ${props => (!props.isLastColumn ? 'margin-right: 5px;' : '')}
  &.file-name {
    width: 25%;
  }

  &.fingerprint {
    width: 12%;
  }

  &.date-time {
    width: 14%;
  }

  &.icon {
    width: 7%;
  }
  @media only screen and (max-width: 600px) {
    &.hide-on-mobile {
      width: 0;
      display: none;
    }
    &.show-on-mobile {
      &.icon {
        width: 20%;
      }
      &.fingerprint {
        width: 30%;
      }

      &.date-time {
        width: 40%;
      }
    }
  }

  &.no-data-value {
    font-size: ${p => p.theme.variables.fonts.size.smaller2};
    color: ${p => p.theme.variables.customColors.lightGreyText};
  }
`;

export const BaseItemRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 10px;
`;
